<template>
  <!--listBody-->
  <div class="content">
    <div class="condition">
      <div class="check_wrap">
        <el-radio-group v-model="listData.type" @change="radioChange" size="small">
          <el-radio-button label="0">全部</el-radio-button>
          <el-radio-button label="1">公司</el-radio-button>
          <el-radio-button label="2">个人</el-radio-button>
        </el-radio-group>
      </div>
      <div class="search_wrap">
        <el-form :inline="true" :model="listData" class="form-inline">
          <el-form-item>
            <el-select clearable v-model="listData.status" placeholder="请选择上架状态" size="small">
              <el-option
                v-for="(item,index) in status"
                :value="item.value"
                :label="item.label"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="listData.title" placeholder="请输入视频标题" size="small">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="dataTime"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small"
              :picker-options="pickerOptions1"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchFn" size="small"></el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="other_wrap">
        <el-button type="primary" @click="publish('add')" size="small">创建视频</el-button>
      </div>     
    </div>
    <!-- <div>
      <div class="other_wrap mb-20 infoBody">
        个人视频自动审核:
        <el-switch
                class="ml10"
                v-model="switch_structure"
                active-color="#2AA3F8"
                inactive-color="#ddd"
                @change="changeswitch()"
        ></el-switch>
        <el-tooltip class="item" effect="light" placement="bottom-start">
          <div slot="content" class="infocontent">
            <p>开始时，个人上传的视频将自动上架，显示在公司视频列表</p>
            <p>关闭时，需要管理员手动上架个人上传的视频</p>
          </div>
          <i class="iconfont iconbangzhu1"></i>
        </el-tooltip>
      </div>
    </div>      -->

    <div class="table_wrap">
      <el-table :data="activeList" style="width: 100%">
        <el-table-column prop="date" type="selection"></el-table-column>
        <el-table-column prop="date" label="视频内容" width="180">
          <template slot-scope="scope">
            <div class="imgbox" @click="openVideo(scope.row)"><img :src="scope.row.cover" alt="" /><i class="el-icon-video-play"></i></div>
          </template>
        </el-table-column>      
        <el-table-column prop="date" label="标题">
          <template slot-scope="scope">{{scope.row.title}}</template>
        </el-table-column>          
        <el-table-column prop="date" label="发布人">
          <template slot-scope="scope">{{scope.row.user_name}}</template>
        </el-table-column>
        <el-table-column prop="date" label="视频来源">
          <template slot-scope="scope">{{scope.row.type==0?'个人':'公司'}}</template>
        </el-table-column>  
        <el-table-column prop="date" label="视频大小">
          <template slot-scope="scope">{{scope.row.size}}M</template>
        </el-table-column>        
        <el-table-column prop="sub_time" label="发布时间">
          <template slot-scope="scope">{{scope.row.create_time}}</template>
        </el-table-column>
        <el-table-column prop="date" label="状态" width="120">
          <template slot-scope="scope">{{scope.row.status==1?'上架中':'已下架'}}</template>
        </el-table-column>         
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="takeOff(scope.$index)">{{scope.row.status==1?'下架':'上架'}}</el-button>
            <el-button type="text" size="small" @click="publish('edit',scope.row.id)">编辑</el-button>
            <el-button type="text" size="small" @click="del(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pag_wrap">
        <el-pagination
          background
          :page-size="page.pagesize"
          :current-page="page.pageindex"
          layout="total, prev, pager, next"
          :total="page.total"
          @current-change="pageIndexChange"
        ></el-pagination>
      </div>
    </div>

    <previewVideoDialog :privaVideoObj="privaVideoObj" :visible.sync="dialogImgVisible"></previewVideoDialog>
  </div>
</template>

<script>
import previewVideoDialog from "@/components/dialog/previewVideoDialog.vue";
import { yeartime, yeartime_ } from "@/assets/js/common";
import { pagination } from "@/util/util.js";
import api from "@/api.js";
export default {
  name: "marketingVideo",
  components: {
    previewVideoDialog
  },
  data() {
    return {
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now(); //  - 8.64e7 减去就是不包含今天的
        },
      }, 
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      },
      status: [
        { value: 0, label: "全部" },
        { value: 1, label: "上架" },
        { value: 2, label: "下架" }
      ],
      activeList: [],
      listData: {
        type: 0, // 当前类型 0全部、1公司、2个人
        status: 0, //查看状态(0全部、1上架、2下架)
        title: "", // 标题
        name: "", // 发布人
        start_time: "", // 开始日期(时间戳)
        end_time: "", // 结束日期(时间戳)
        keyword: "" // 关键词查找
      },
      privaVideoObj: {
        title: "",
        url: ""
      },
      dataTime: [],
      dialogImgVisible: false,
      optionList: [],
      switch_structure: false  // 个人视频是否自动审核
    };
  },
  created() {
    this.InitFn();
  },
  watch: {
    ['listData.status']: function(val) {
      this.InitFn();
    }
  },
  methods: {
    openVideo(option) {
      this.privaVideoObj.title = option.title;
      this.privaVideoObj.url = option.url;
      this.dialogImgVisible = true
    },
    //搜索
    searchFn() {
      this.listData.page = 1;
      if (this.dataTime) {
        if (this.dataTime.length !== 0) {
          this.listData.start_time = yeartime_(this.dataTime[0]);
          this.listData.end_time = yeartime_(this.dataTime[1]);
        } else {
          this.listData.start_time = '';
          this.listData.end_time = '';
        }
      } else {
        this.listData.start_time = '';
        this.listData.end_time = '';
      }
      this.InitFn();
    },    
    publish(option, id) {
      let self_ = this;
      if (option === "edit") {
        this.$router.push({name: "addOrEditVideo", query: {pageType: option, id: id}});   
      } else {
        this.$router.push({name: "addOrEditVideo", query: {pageType: option}});
      };      
    },  
    del(index) {
      let self_ = this;
      this.$confirm('确认删除该视频?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self_.axios
            .post('companyadmin/video_diary/delete', {video_id: self_.activeList[index].id})
            .then(response => {
              if (response.data.code == 0) { 
                self_.$message({
                  message: '删除成功!'
                });
                self_.InitFn();
              }; 
            })
            .catch(response => {
            });         
      }).catch(() => {
         
      });          
    }, 
    // 视频下架
    takeOff(index) {
      let self_ = this;
      self_.axios
          .post('companyadmin/video_diary/editStatus', {video_id: self_.activeList[index].id, status: self_.activeList[index].status == 0 ? 1 : 0})
          .then(response => {
            if (response.data.code == 0) { 
              self_.InitFn();
            }; 
          })
          .catch(response => {
          });
    },
    radioChange(option) {
      // 选择radio
      this.listData.type = option;
      this.listData.page = 1;
      this.InitFn(); 
    },
    // 分页
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.InitFn();
    },
    InitFn() {
      this.listData.page = this.page.pageindex;
      this.axios
        .post(api.companyadmin_video_diary_index, this.listData)
        .then(response => {
          if (response.data.code == 0) {
            this.activeList = response.data.list;
            this.page.total = response.data.all_page;
          } else {
          }
        })
        .catch(() => {});
    },
    changeswitch() {
      const loading = this.$loading({
        lock: true,
        text: '设置中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)',
        customClass:'fontColor'
      });
      let switch_structure = 0;
      if(this.switch_structure){
        switch_structure = 1;
      }
      this.axios
          .post(api.diary_person, {dynamic_person:switch_structure})
          .then(response => {
            if (response.data.code == 0) {
              setTimeout(()=>{
                loading.close();
              },300)
            } else {
            }
          })
          .catch(response => {
          });
    }
  }
};
</script>

<style scoped>
.imgbox{position: relative; display: inline-block;}
.imgbox::before{position: absolute; display: block; content: ""; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,.5);}
.imgbox img{max-height: 127px; max-width: 127px; width: auto; vertical-align: middle;}
.imgbox .el-icon-video-play{position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); color: #fff; font-size: 28px;}
</style>